export const INSPECT = 'app/UserInspect/INSPECT';
export const CONFIRM_INSPECT = 'app/UserInspect/CONFIRM_INSPECT';
export const GET_DATA = 'app/UserInspect/GET_DATA';
export const HAS_ERROR = 'app/UserInspect/HAS_ERROR';
export const PAGE_DATA = 'app/UserInspect/PAGE_DATA';
export const SET_SESSION_DETAILS_DATA =
  'app/UserInspect/SET_SESSION_DETAILS_DATA';
